import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { matchPath } from 'react-router';
import { hasValidVideolandCookie } from '../helpers/authentication';
import { cookie } from '../helpers/storage';
import { AUTOLOGIN_COOKIE_BR, AUTH_DOMAIN } from '../config';
import { getDateNextYear } from '../helpers/datetime';
import { getTierOptionsRedirectRoute } from '../constants/Routes';
import { allowedAuthenticatedRoutes } from '../helpers/routes';

export function autoLoginBR(expires) {
	cookie.set(AUTOLOGIN_COOKIE_BR, true, {
		domain: AUTH_DOMAIN,
		expires: expires ? new Date(expires) : getDateNextYear(),
		httpOnly: false,
		path: '/',
		secure: true,
	});
}

export function useRedirectUser() {
	const { expires, redirectUrl } = useSelector((state) => state.authentication);
	const isLoggedin = hasValidVideolandCookie();

	useEffect(() => {
		if (isLoggedin) {
			autoLoginBR(expires);
			const fallbackRoute = getTierOptionsRedirectRoute();
			const { pathname } = window.location;
			const isRouteAllowed = !!matchPath(pathname, { path: allowedAuthenticatedRoutes });

			if (redirectUrl && pathname !== redirectUrl) {
				window.location.href = `${window.location.origin}${redirectUrl}`;
			} else if (!redirectUrl && pathname !== fallbackRoute && !isRouteAllowed) {
				window.location.href = `${window.location.origin}${fallbackRoute}`;
			}
		}
	}, [isLoggedin, expires, redirectUrl]);
}
